import style from './Button.module.css'

export default function Button(props) {
  var colorButton = ''
  if (props.color === undefined || props.color === 'primary') {
    colorButton = style.button_primary
  }
  if (props.color === 'secondary') {
    colorButton = style.button_secondary
  }
  if (props.color === 'tertiary') {
    colorButton = style.button_tertiary
  }

  if (props.color === 'blue') {
    colorButton = style.button_blue
  }

  if (props.color === 'violet') {
    colorButton = style.button_violet
  }

  
  return (
    <button
      disabled={props.disabled ? true : false}
      className={`${colorButton} ${props.className}`}
      style={{ display: props.display, backgroundColor: props.background }}
      onClick={props.onClick}
      type={props.type}
    >
      {props.title || props.children}
    </button>
  )
}
